import { ResourcesConfig } from 'aws-amplify';

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-1_AJV82lzTc',
      userPoolClientId: '7ih2csik6k10a2qtj7an7a85vp',
      loginWith: {
        oauth: {
          domain: 'login.tailor.wf',
          scopes: [
            'phone',
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: ['https://tailor.wf/'],
          redirectSignOut: ['https://tailor.wf/'],
          responseType: 'code',
        },
      },
    },
  },
};
export default amplifyConfig;
